import React, { Component } from 'react';
import { connect } from 'react-redux';
import PageTitle from '../../common/page-title';
import { Row, Col } from 'react-bootstrap';
import ArrowButton from '../../common/button-arrow';
import { Link } from 'react-router-dom';
import IncentivesList from './incentives-list';
import { getIncentives } from '../../../actions/incentives';

import './styles.css'

class Incentives extends Component {
  componentWillMount() {
    const { dispatch } = this.props;

    dispatch(getIncentives());

    this.state = {
      pageNumber: 1
    };
  }

  handlePageChange = (page, size) => {
    this.setState({ pageNumber: page }, () => this.props.dispatch(getIncentives(page)));
  };

    render() {
        return (
            <div className="container-fluid incentives">
                <Row>
                    <PageTitle>Sales Incentives</PageTitle>
                    <Col md={12}>
                        <Row>
                            <Link to="/admin/sales_incentives/new">
                              <ArrowButton color="red"
                                           arrow={false}
                                           submit={false}
                                           permissions={{
                                             action:       "create",
                                             subjectClass: "Incentive",
                                           }}
                                           className="add-incentive">New sales Incentive</ArrowButton>
                            </Link>
                        </Row>
                    </Col>

                    <Row>
                        <Col md={12}>
                            <IncentivesList
                                incentives={this.props.incentives}
                                fetching={this.props.fetching}
                                fetched={this.props.fetched}
                                pagination={this.props.pagination}
                                onPageChange={this.handlePageChange}
                                currentPage={this.state.pageNumber}/>
                        </Col>
                    </Row>
                </Row>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
  return {
    incentives: state.incentives.incentives,
    fetching: state.incentives.fetching,
    fetched: state.incentives.fetched,
    pagination:   state.incentives.paging,
  };
};

export default connect(mapStateToProps)(Incentives);



// WEBPACK FOOTER //
// ./src/components/admin/incentives/index.jsx